import { formatDate } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TASK_LIST_URL } from '@insite-store360/shared';
import { BehaviorSubject, catchError, Observable } from 'rxjs';
import { ErrorHandlerService } from './error-handler.service';
@Injectable({
  providedIn: 'root'
})
export class TaskListService {

  private selectedRowDataDSource = new BehaviorSubject<any>(null);
  selectedRowData$ = this.selectedRowDataDSource.asObservable();
  private readonly TASK_API = `${TASK_LIST_URL}`
  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandlerService
  ) { }


  setSelectedRow(data: any): void {
    this.selectedRowDataDSource.next(data);
  }

  clearSelectedRow(): void {
    this.selectedRowDataDSource.next(null);
  }


  public getAllTask(
    pageIndex: Number,
    pageSize: Number,
    searchValue?: string,
    userId?: Number,
  ): Observable<any> {

    if (searchValue) {
      return this.http.get<any>(
        `${this.TASK_API}/getAll?id=${userId}&pageIndex=${pageIndex}&pageSize=${pageSize}&searchValue=${searchValue}`,
      ).pipe(catchError(this.errorHandler.handleError))
    } else {
      return this.http.get<any>(
        `${this.TASK_API}/getAll?id=${userId}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      ).pipe(catchError(this.errorHandler.handleError))
    }

  }

  public getAllFilterTask(
    pageIndex: Number,
    pageSize: Number,
    filterOptions: {
      storeId?: number,
      frequency?: number;
      status?: string;
      roleId?: number;
      duration?: {
        dueDate?: string,
        startDate?: string
      };
    } = {},
    userId?: Number,
  ): Observable<any> {
    let params = new HttpParams()
      .set('pageIndex', pageIndex.toString())
      .set('pageSize', pageSize.toString());

    Object.entries(filterOptions).forEach(([key, value]) => {
      if (key === 'duration' && typeof value === 'object') {
        // Format dates to 'YYYY-MM-DD' to avoid timezone issues
        if (value.startDate) {
          const formattedStartDate = formatDate
            (value.startDate, 'yyyy-MM-dd', 'en-US');
          params = params.set('startDate', formattedStartDate);
        }
        if (value.dueDate) {
          const formattedDueDate = formatDate(value.dueDate, 'yyyy-MM-dd', 'en-US');
          params = params.set('dueDate', formattedDueDate);
        }
      } else if (value) {
        params = params.set(key, value.toString());
      }
    });

    return this.http.get<any>(
      `${this.TASK_API}/getAll?id=${userId}`, { params }
    ).pipe(catchError(this.errorHandler.handleError));
  }

  // ---------------  Add The Task List To the Backend ----------- //
  public addTaskDetails(taskDetails: any): Observable<any> {
    return this.http
      .post<any>(`${this.TASK_API}/save`, taskDetails)
      .pipe(catchError(this.errorHandler.handleError));
  }

  // ---------- Delete task ------------- //
  public deleteStore(id: number): Observable<string> {
    return this.http
      .delete<string>(`${this.TASK_API}/delete/${id}`)
      .pipe(catchError(this.errorHandler.handleError));
  }

  // ----------- Get Task Summary -------- //
  public getTaskSummary(): Observable<any> {
    return this.http.get<any>(
      `${this.TASK_API}/task-status-summary`
    ).pipe(catchError(this.errorHandler.handleError))
  }

  //Update Task
  public updateTaskList(data: any): Observable<any> {
    return this.http
      .put<any>(`${this.TASK_API}/update`, data)
      .pipe(catchError(this.errorHandler.handleError));
  }

  // Fetch the Filter Options
  public getAllFilterOptions(searchFilter?: string): Observable<any> {
    if (searchFilter) {
      return this.http.get<any>(
        `${this.TASK_API}/getAllFilterDetails/searchFilter=${searchFilter}`
      )
        .pipe(catchError(this.errorHandler.handleError))
    } else {
      return this.http.get<any>(
        `${this.TASK_API}/getAllFilterDetails`
      )
    }
  }

  // Based on the ID Fetch the Task Details
  public getTaskDetailsById(
    id: Number,
    pageIndex: Number,
    pageSize: Number,
    searchValue?: string
  ): Observable<any> {

    if (searchValue) {
      return this.http.get<any>(
        `${this.TASK_API}/taskDetails/${id}?pageIndex=${pageIndex}&pageSize=${pageSize}&searchValue=${searchValue}`
      ).pipe(catchError(this.errorHandler.handleError))
    } else {
      return this.http.get<any>(
        `${this.TASK_API}/taskDetails/${id}?pageIndex=${pageIndex}&pageSize=${pageSize}`
      ).pipe(catchError(this.errorHandler.handleError))
    }


  }


  // getfrequencyType

  public getFrequencyType(): Observable<any> {
    return this.http.get<any>(
      `${this.TASK_API}/getAllFrequency`
    ).pipe(catchError(this.errorHandler.handleError))
  }

}
